
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { handleActiveSelect } from "../../features/layout/layoutSlice"
import { IoIosArrowDown } from "react-icons/io"
import { useEffect } from "react"

const Container = styled.div`
      width: ${({width})=> width};
      position: relative;
      user-select: none;

      .dropdown-btn{
        padding: 7px 10px;
        width: 100%;
        font-size: 16px;
        font-weight: var(--font-weight-md);
        line-height: 12px;
        text-align: left;
        background-color: ${({ theme }) => theme.mainBgColor};
        color: ${({ theme }) => theme.mainTextColor};
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};

      }

      .dropdown-content{
        position: absolute;
        max-height: 300px;
        overflow: auto;
        top: 110%;
        left: 0;
        color: ${({ theme }) => theme.mainTextColor};
        font-weight: var(--font-weight-md);
        background-color: ${({ theme }) => theme.mainBgColor};
        width: 100%;
        z-index: 10;
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};

        &::-webkit-scrollbar {
        width: 5px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: #9e9b9b;
            border-radius: 10px;
        }
        &::-webkit-scrollbar-track {
            background-color: transparent;
        }

        .dropdown-item{
          font-size: 16px;
          font-weight: var(--font-weight-md);
          line-height: 12px;
          text-align: left;
          padding: 10px;
          cursor: pointer;
          transition: all .2s;  

          &:hover{
            background-color: ${({ theme }) => theme.secondaryBgColor};
          }
        }
      }
`

const SingleInputSelectNew = ({ options, name, current, width, handleChange, isSubmitted, requiredFields}) => {
    
  //! bu select tamamen option a tıklandığında select üzerindeki gözükecek olan kısım için 
  const [selected, setSelected] = useState(null)

  // bu activeSelect select le alakalı
  const {activeSelect} = useSelector(state => state.layout)

  //! bu error state eğer input gerekli ve doldurulmamışsa 
  const [isError, setIsError] = useState(false)
  const dispatch = useDispatch()

  useEffect(()=> {
    if(isSubmitted && requiredFields && !current.value){
      if (requiredFields.includes(name)){
        setIsError(true)
      }
    }
    else{
      setIsError(false)
    }
  },[isSubmitted,requiredFields,current.value])

  const handleSelectClick = () => {
    //! bu seselct le alakalı tıklandığında select varsa ve select === bunun name ine ise sect i kapatıyor yoksa select e bunun name ini atayıp bu select i açtırıyor. 
    dispatch(handleActiveSelect((activeSelect && activeSelect === name) ? null : name))
  }

  const handleOptionClick =(item) => {
    //! değişikliği gönderiyor
    handleChange(item)

    //! bu tamamen select le alakalı tıklandığında açık olan select i kapatmak için
    dispatch(handleActiveSelect(null))

    //! buradaki select i option a tıklandığında tıklanan option ı göstermek için(bu selected gereksiz gibi)
    setSelected(item.text)
  }

  return (
    <Container className="dropdown" onClick={(e) => e.stopPropagation()} width={width}  isError={isError}>
    <div className="dropdown-btn" onClick={handleSelectClick}>{current.text || "Seçiniz..."} <IoIosArrowDown/></div>
    {(activeSelect === name)  &&
      <div className="dropdown-content">
        {
          options.map((item, i)=>(
            <div key={i} onClick={() => handleOptionClick(item)} className="dropdown-item">{item.text}</div>
          ))
        }
      </div>
    }
    </Container>
  )
}

export default SingleInputSelectNew